module.exports = __webpack_public_path__ + "img/logo-en-botton-white.2ecdb09.svg";